/**
 * FxIcon/index.js
 * desc: "fx" icon used by expression editor
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const FxIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="fx icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.fx.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 24"><path d="M8.396 8.837l-.711 7.11c-.159 1.612-.405 2.84-.739 3.683-.328.844-.861 1.602-1.6 2.276-1.083.99-2.3 1.486-3.647 1.486-.27 0-.615-.074-1.037-.22L1.831 22.1c.498.164.95.246 1.354.246 1.728 0 2.727-1.31 2.997-3.929l.228-2.18.738-7.4h-1.59l1.002-1.02h.694l.053-.51c.21-2.167.835-3.855 1.872-5.062 1.037-1.213 2.376-1.82 4.016-1.82.31 0 .66.03 1.046.089l-1.23 1.213c-.44-.17-.87-.255-1.292-.255-1.008 0-1.726.348-2.154 1.046-.427.697-.738 2.033-.931 4.007l-.132 1.292h3.56l-1.046 1.02h-2.62zM14.865 12.15l-.272-.72-.325-.826-.422-.94c-.3-.675-.586-1.012-.862-1.012-.416 0-.744.39-.984 1.17-.176-.065-.264-.159-.264-.282 0-.363.211-.78.633-1.248.422-.469.8-.703 1.134-.703.656 0 1.336.943 2.039 2.83l.176.466.202-.325c1.248-1.98 2.3-2.971 3.155-2.971.223 0 .484.064.782.193l-1.063 1.116a1.255 1.255 0 00-.299-.061c-.644 0-1.412.741-2.303 2.223l-.255.422.203.545c.773 2.127 1.409 3.19 1.907 3.19.457 0 .805-.327 1.046-.984.164.106.246.214.246.326 0 .293-.234.644-.703 1.054-.469.41-.873.616-1.213.616-.68 0-1.374-.958-2.083-2.874l-.246-.65-.255.447c-1.195 2.051-2.338 3.077-3.428 3.077-.41 0-.759-.103-1.046-.308l1.02-1.002c.175.176.38.264.615.264.662 0 1.406-.668 2.232-2.004l.458-.739.175-.29z"/></svg>
    </IconButton>
);


export default FxIcon;
